import { assetUrl } from './asset-url.js';
const STORAGE_KEYS = {
  sfx: 'interactive-book:sfx',
  music: 'interactive-book:music'
};

function readBoolean(key, fallback) {
  const raw = window.localStorage.getItem(key);
  if (raw === null) return fallback;
  return raw === 'true';
}

export function createAudioController(audioConfig = {}) {
  const flipAudio = audioConfig.flip ? new Audio(assetUrl(audioConfig.flip)) : null;
  const backgroundAudio = audioConfig.bgm ? new Audio(assetUrl(audioConfig.bgm)) : null;

  if (flipAudio) flipAudio.preload = 'auto';
  if (backgroundAudio) {
    backgroundAudio.preload = 'none';
    backgroundAudio.loop = true;
    backgroundAudio.volume = Number(audioConfig.bgmVolume ?? 0.18);
  }

  let sfxEnabled = readBoolean(STORAGE_KEYS.sfx, true);
  let musicEnabled = readBoolean(STORAGE_KEYS.music, false);
  let userActivatedAudio = false;

  async function unlockFromGesture() {
    userActivatedAudio = true;
    if (musicEnabled) await playMusic();
  }

  async function playFlip() {
    if (!sfxEnabled || !flipAudio || !userActivatedAudio) return;

    try {
      flipAudio.currentTime = 0;
      await flipAudio.play();
    } catch {
      // Playback can be rejected by browser policy. The UI remains usable without audio.
    }
  }

  async function playMusic() {
    if (!musicEnabled || !backgroundAudio || !userActivatedAudio) return false;

    try {
      await backgroundAudio.play();
      return true;
    } catch {
      return false;
    }
  }

  function pauseMusic() {
    backgroundAudio?.pause();
  }

  async function setMusicEnabled(enabled) {
    musicEnabled = Boolean(enabled);
    window.localStorage.setItem(STORAGE_KEYS.music, String(musicEnabled));

    if (musicEnabled) return playMusic();
    pauseMusic();
    return true;
  }

  function setSfxEnabled(enabled) {
    sfxEnabled = Boolean(enabled);
    window.localStorage.setItem(STORAGE_KEYS.sfx, String(sfxEnabled));
  }

  function destroy() {
    pauseMusic();
    if (flipAudio) flipAudio.src = '';
    if (backgroundAudio) backgroundAudio.src = '';
  }

  return {
    unlockFromGesture,
    playFlip,
    setMusicEnabled,
    setSfxEnabled,
    destroy,
    get state() {
      return { sfxEnabled, musicEnabled, hasSfx: Boolean(flipAudio), hasMusic: Boolean(backgroundAudio) };
    }
  };
}
